import React from 'react';
import Helmet from 'react-helmet';
import type { MessageDescriptor } from 'react-intl-next';
import { useIntl } from 'react-intl-next';

// Overrides the title and favicon of
// the doc coming from the server.

interface DocumentTitleWithIconProps {
    title: MessageDescriptor;
    iconUrl: string;
}

export const DocumentTitleWithIcon: React.VFC<DocumentTitleWithIconProps> = ({ title, iconUrl }) => {
    const { formatMessage } = useIntl();
    return (
        <Helmet>
            <title>{formatMessage(title)}</title>
            <link rel="shortcut icon" href={iconUrl} />
        </Helmet>
    );
};

export default DocumentTitleWithIcon;
